import { render, staticRenderFns } from "./CooperativePriceEdit.vue?vue&type=template&id=262d3e23&scoped=true&"
import script from "./CooperativePriceEdit.vue?vue&type=script&lang=js&"
export * from "./CooperativePriceEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "262d3e23",
  null
  
)

export default component.exports